import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlunoService } from '../../services/aluno-service';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { LoginService } from '../../services/login-service';
import { ToastrService } from 'ngx-toastr';
import { Aluno } from '../../models/aluno'

@Component({
  selector: 'app-aluno',
  templateUrl: './aluno.component.html',
  styleUrls: ['./aluno.component.scss']
})
export class AlunoComponent implements OnInit {

  aluno: Aluno
  insertForm: FormGroup
  constructor(public fb: FormBuilder, public alunoService: AlunoService, public loginService: LoginService, private toastr: ToastrService) {
    this.insertForm = fb.group({
      nome: [null, [Validators.required]],
      endereco: [null, [Validators.required]],
      municipioUF: [null, [Validators.required]],
      nomeDaMae: [null, [Validators.required]],
      nomeDoPai: [null, [Validators.required]],
      naturalidade: [null, [Validators.required]],
      nacionalidade: [null, [Validators.required]],
      dataDeNascimento: [null, [Validators.required]],
      rg: [null, [Validators.required]],
      orgaoExpedidor: [null, [Validators.required]],
      dataExpedicao: [null, [Validators.required]],
      cpf: [null, [Validators.required]],
      telefone: [null, [Validators.required]],
      observacao: [null, [Validators.required]],
      email: [null, [Validators.required]],
      senha: [null, [Validators.required]],
      matricula: [null, [Validators.required]],
    })
  }

  ngOnInit() {
  }

  //admin@pecteresopolis.com
  build(){
    this.aluno = new Aluno()
    this.aluno.nome = this.insertForm.controls['nome'].value
    this.aluno.endereco = this.insertForm.controls['endereco'].value
    this.aluno.municipioUF = this.insertForm.controls['municipioUF'].value
    this.aluno.nomeDaMae = this.insertForm.controls['nomeDaMae'].value
    this.aluno.nomeDoPai = this.insertForm.controls['nomeDoPai'].value
    this.aluno.naturalidade = this.insertForm.controls['naturalidade'].value
    this.aluno.nacionalidade = this.insertForm.controls['nacionalidade'].value
    this.aluno.rg = this.insertForm.controls['rg'].value
    this.aluno.orgaoExpedidor = this.insertForm.controls['orgaoExpedidor'].value
    this.aluno.dataExpedicao = this.insertForm.controls['dataExpedicao'].value
    this.aluno.cpf = this.insertForm.controls['cpf'].value
    this.aluno.telefone = this.insertForm.controls['telefone'].value
    this.aluno.observacao = this.insertForm.controls['observacao'].value
    this.aluno.email = this.insertForm.controls['email'].value
    this.aluno.matricula = this.insertForm.controls['matricula'].value
    this.aluno.dataDeNascimento = this.insertForm.controls['dataDeNascimento'].value
  }

  clear(){
    this.insertForm.patchValue({
      nome: null,
      endereco: null,
      municipioUF: null,
      nomeDaMae: null,
      nomeDoPai: null,
      naturalidade: null,
      nacionalidade: null,
      dataDeNascimento: null,
      rg: null,
      orgaoExpedidor: null,
      dataExpedicao: null,
      cpf: null,
      telefone: null,
      observacao: null,
      email: null,
      senha: null,
      matricula: null
    })
  }
  save(){
    this.build()
    if(!this.aluno.email || this.aluno.email.toString().trim().length === 0){
      this.toastr.error("Informe um email válido");
      return;
    }
    var senha = this.insertForm.controls['senha'].value
    if(!senha || senha.toString().trim().length === 0){
      this.toastr.error("Informe a senha do aluno");
      return;
    }
    this.loginService.createAccount(this.aluno.email, senha).then((res)=>{
      this.alunoService.insert(this.aluno, res.user.uid).then(()=>{
          this.toastr.success("Aluno cadastrado.")
          this.clear();
      })
    }).catch(res=>{

      if(res.code === "auth/invalid-email")
        this.toastr.error("Insira um email válido.");
      else if(res.code === "auth/weak-password")
        this.toastr.error("Insira uma senha com pelo menos 6 caracteres.")
      else if(res.code === "auth/email-already-in-use")
        this.toastr.error("Este email já está em uso.")
      else
        this.toastr.error("Ocorreu um erro, tente novamente.")
    })
  }

}
